import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Image from 'react-bootstrap/Image';


const Me = () => (
    <Jumbotron className="p-3 mb-0">
        <Row className="m-0">
            <Col xs={8} md={8} lg={8} className="pl-0">
                <h2 style={{textAlign:"right", marginBottom:"3mm"}}>Travis Desell, Ph.D.</h2>
                <p className='lead' style={{textAlign:"right"}}>
                    Associate Professor<br/>
                    <small>Department of Software Engineering<br/>
                        Rochester Institute of Technology</small>
                </p>
            </Col>


            <Col xs={4} md={4} lg={4} className="pr-0">
                <Image src='./assets/img/me.jpg' rounded fluid />
            </Col>
        </Row>
    </Jumbotron>
);


export default Me;
